/* eslint-disable */
import * as React from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { Pagination, PaginationItem, PaginationRenderItemParams } from "@mui/material";
import LanguageStrings from '../i18n/locales';

const ComponentsStrings = LanguageStrings().Components

export default function TablePagination(props: any) {
  const { page, rowsPerPage, setPage, selectedPages } = props;
  const totalAssets = props.count;
  const pageCount = Math.ceil(totalAssets / rowsPerPage)
  const [textFieldValue, setTextFieldValue] = React.useState(page.toString())

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  }
  const handleKeyEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // istanbul ignore else
    if (event.key === 'Enter') {
      let value = textFieldValue || 1
      // istanbul ignore else
      if (value === "" || (Number(value) >= 1 && Number(value) <= pageCount)) {
        handlePageChange(event, Number(value))
      }
      else {
        if (isNaN(value)) {
          value = '1'
        }
        value = (Math.min(Math.max(Number(value), 1), pageCount)).toString()
        handlePageChange(event, Number(value))
        setTextFieldValue(value.toString())
      }
    }
  }
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isNaN(parseInt(event.target.value))) {
      setTextFieldValue(parseInt(event.target.value))
    } else if (event.target.value === '') {
      setTextFieldValue(event.target.value)
    }
  }

  const renderPaginationItem = (item: PaginationRenderItemParams) => {
    if (item.type === 'page') {
      return (
        <PaginationItem
          {...item}
          components={{
            previous: () => <span>‹</span>,
            next: () => <span>›</span>,
          }}
          sx={selectedPages !== undefined && selectedPages.includes(item.page) ?
            {
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: '-1px',  // Positions circle above the page number
              right: '38%',  // Positions circle to the right of the page number
              width: '5px',  // Larger size for visibility
              height: '5px',  // Larger size for visibility
              borderRadius: '50%',  // Makes it a circle
              backgroundColor: '#64C3FF',  // Blue for visibility (adjust as needed)
              zIndex: 1,  // Ensures circle is on top
            },
          }
          : {}
          }
        />
      );
    }
    return <PaginationItem {...item} />;
  };

  return (
    <Stack
      aria-label="pagination-component"
      className="device-pagination"
      direction={{ xs: "column", sm: "row" }}
      spacing={{ xs: 1, sm: 2, md: 4 }}
      justifyContent="space-between"
      alignItems="center"
      sx={{ borderLeft: '1px solid #202020', borderRight: '1px solid #202020' }}
    >
      <div className="total-items">
        {(page >= 1 && totalAssets != 0) ? (
          <>
            {(page - 1) * rowsPerPage + 1}-
            {Math.min(page * rowsPerPage, totalAssets)} {ComponentsStrings.of} {totalAssets} {ComponentsStrings.items}
          </>
        ) : (
          ""
        )}
      </div>
      <Pagination
        count={pageCount}
        page={page}
        onChange={handlePageChange}
        sx={{ ml: 2, mr: 2 }}
        renderItem={renderPaginationItem}
      />
      <React.StrictMode>
        <Stack direction="row" alignItems="center">
          <div className="gotoAndTextfield">
            <div className="goTo" data-testid="goto">
              {" "}
              {ComponentsStrings.GoToPage}{" "}
            </div>
            <TextField
              size="small"
              className="AmiTableGoto"
              variant="outlined"
              inputProps={{
                min: 1,
                max: pageCount,
                role: "goto-page",
                color: "white",
                sx: {
                  color: "white",
                },
              }}
              value={textFieldValue}
              onChange={handleChange}
              onKeyDown={handleKeyEnter}
            />
          </div>
        </Stack>
      </React.StrictMode>
    </Stack>
  );
}
